import React, { useState, useEffect, useRef } from 'react';
import Navbar from "../features/Navbar";
import Footer from '../components/Footer';

const Video = () => {
  const [videos, setVideos] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null); // Store the current video ID to play
  const [currentVideoDetails, setCurrentVideoDetails] = useState({}); // Store video title and date
  const videoPlayerRef = useRef(null); // Reference to the video player for scrolling
  const CHANNEL_ID = 'UCEDY0y5DWKikCYzdKJILkiw'; // Replace with your channel ID
  const RSS_URL = `https://www.youtube.com/feeds/videos.xml?channel_id=${CHANNEL_ID}`;

  useEffect(() => {
    // Fetch the RSS feed
    const fetchRSS = async () => {
      try {
        const response = await fetch(`https://api.rss2json.com/v1/api.json?rss_url=${RSS_URL}`);
        const data = await response.json();

        console.log('Fetched Data:', data); // Debugging Log

        // Filter out only the videos (no live streams)
        const filteredVideos = data.items.filter((video) => !video.link.includes('live'));

        // Set the videos
        setVideos(filteredVideos);

        // Set the current video to the first video if available
        if (filteredVideos.length > 0) {
          const firstVideo = filteredVideos[0];
          const videoId = firstVideo.link.split('=')[1];
          setCurrentVideo(videoId);
          setCurrentVideoDetails({
            title: firstVideo.title,
            pubDate: firstVideo.pubDate
          });
        }
      } catch (error) {
        console.error('Error fetching RSS feed:', error);
      }
    };

    fetchRSS();
  }); // Empty dependency array to fetch only once

  // Function to handle when a video is clicked
  const handleVideoClick = (video) => {
    const videoId = video.link.split('=')[1];
    setCurrentVideo(videoId);
    setCurrentVideoDetails({
      title: video.title,
      pubDate: video.pubDate
    });

    // Scroll to the video player
    videoPlayerRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="w-full h-full">
      <div className='sticky top-0 z-50'>
        <Navbar />
      </div>

      <div className="container mx-auto p-4">
        <h1 className="text-3xl font-bold mb-6">Videos</h1>

        {/* Video Player Section */}
        <div ref={videoPlayerRef} className="mb-8 w-full">
          {currentVideo ? (
            <>
              <iframe
                width="100%"
                height="500"
                className="rounded-md"
                src={`https://www.youtube.com/embed/${currentVideo}`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="YouTube Video Player"
              ></iframe>

              {/* Video Title and Date */}
              <div className="mt-4 text-center">
                <h2 className="text-2xl font-semibold">{currentVideoDetails.title}</h2>
                <p className="text-gray-600">{new Date(currentVideoDetails.pubDate).toLocaleDateString()}</p>
              </div>
            </>
          ) : (
            <div className="text-xl text-center p-8">No video selected</div>
          )}
        </div>

        {/* Videos Section */}
        <h2 className="text-2xl font-semibold mb-4">All Videos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video) => (
            <div
              key={video.guid}
              className={`bg-white p-4 shadow-md cursor-pointer transition-transform duration-200 hover:scale-105 ${currentVideo === video.link.split('=')[1] ? 'border-2 border-[#b29700]' : ''}`}
              onClick={() => handleVideoClick(video)} // Click to set the video
            >
              <img
                src={video.thumbnail}
                alt={video.title}
                className="w-full h-48 object-cover rounded-md"
              />
              <h2 className="text-lg font-semibold mt-2">{video.title}</h2>
              <p className="text-sm text-gray-600">{video.description}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Video;
